import { render } from "./client-dialog.vue?vue&type=template&id=c2b52db4&scoped=true"
import script from "./client-dialog.vue?vue&type=script&lang=js"
export * from "./client-dialog.vue?vue&type=script&lang=js"

import "./client-dialog.vue?vue&type=style&index=0&id=c2b52db4&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b52db4"]])

export default __exports__